export default {
    config: function() {
        var config = {
            checkUrl: "/modules/point/yescoin/check",
            redeemUrl: "/modules/point/yescoin/redeem",
            redeemUrlSpecial: {
                'lineCiti': '/modules/point/yescoin/citi',
            }
        }
        return config;
    },
}
